import { lazy } from 'react';

export const LazyNoAccessErrorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--no-access-error-page" */ './no-access-error-page'
    ),
);
